module.exports = __webpack_public_path__ + "img/J10818.a1a0336e.png";